import { styled } from 'styled-components';

export const Container = styled.div`
  background: ${({ theme }) => theme.colors.white};
  display: flex;
  justify-content: center;
  padding: 2rem;
`;
